import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";
import { CHAT_ELEMENT_HEIGHT } from "../components/consts/sizeConsts";

export const useInputStyles = makeStyles((theme: Theme) =>
  createStyles({
    input: {
      textAlign: "left",
      backgroundColor: "white",
      fontSize: "16px",
      width: "100%",
      fontWeight: 500,
      height: CHAT_ELEMENT_HEIGHT,
    },
  }),
);
